var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwapArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.106,
    height: 18.835,
    viewBox: "0 0 24.106 18.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "swap-icon",
    "data-name": "Icon awesome-exchange-alt",
    d: "M0,9.21V8.457a1.13,1.13,0,0,1,1.13-1.13H18.08V5.067a1.131,1.131,0,0,1,1.929-.8l3.767,3.767a1.13,1.13,0,0,1,0,1.6L20.009,13.4a1.131,1.131,0,0,1-1.929-.8V10.34H1.13A1.13,1.13,0,0,1,0,9.21Zm22.977,7.157H6.027v-2.26a1.131,1.131,0,0,0-1.929-.8L.331,17.075a1.13,1.13,0,0,0,0,1.6L4.1,22.439a1.131,1.131,0,0,0,1.929-.8V19.38h16.95a1.13,1.13,0,0,0,1.13-1.13V17.5A1.13,1.13,0,0,0,22.977,16.367Z",
    transform: "translate(0 -3.936)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapArrows);
export default __webpack_public_path__ + "static/media/SwapArrows.b78341165d4ce6e39038a0588718be16.svg";
export { ForwardRef as ReactComponent };